import { useEffect, useRef } from "react";
import { launchGame } from "../player/launch";
import { getAccount } from "../lib/account";
import type { GameDetail } from "../lib/types";

// The imperative game island. React renders only the empty stage div; one effect
// (keyed on game.id) hands it to the right launch adapter and tears down on
// unmount. React never renders children here, so the engine DOM is never
// reconciled away.
export function GameStage({ game }: { game: GameDetail }) {
  const stageRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const stage = stageRef.current;
    if (!stage) return;
    let cleanup: (() => void) | null = null;
    let cancelled = false;

    launchGame(stage, game, getAccount())
      .then((c) => {
        if (cancelled) c();
        else cleanup = c;
      })
      .catch((err) => {
        const p = document.createElement("p");
        p.className = "empty";
        p.textContent = `The game failed to start: ${err?.message || err}`;
        stage.replaceChildren(p);
      });

    return () => {
      cancelled = true;
      cleanup?.();
    };
  }, [game.id]);

  return <div ref={stageRef} className="stage" tabIndex={-1} />;
}
